import rfdc from 'rfdc';
export const clone = rfdc();
/**
 * Returns merged objects
 * @param {...object} sources array of objects
 * @returns {object} merged object
 */ export const merge = (...sources)=>sources.reduce((acc, current)=>{
        // loop through current's keys
        Object.keys(current).forEach((k)=>{
            const accVal = acc[k];
            const curVal = current[k];
            if (curVal !== null && typeof curVal === 'object' && accVal !== null && typeof accVal === 'object' && !Array.isArray(curVal) && !Array.isArray(accVal)) {
                acc[k] = merge(accVal, curVal);
            } else {
                acc[k] = curVal;
            }
        });
        return acc;
    }, {});
/**
 * determines if an object is empty or not
 * @param {object} obj
 * @returns {boolean} true if object is empty, false otherwise
 */ export const isEmpty = (obj)=>Object.keys(obj).length === 0;
